const routes = [
    {
        path: '/report/list',
        component: function () {
            return import('@/components/admin/report/ReportList')
        }
    }
]

export default routes
